"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Header_1 = require("../components/Header/Header");
var Banner_1 = require("../components/Banner/Banner");
var targetNode = document.querySelector('#header');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(Header_1.default, null),
        (0, preact_1.h)(Banner_1.default, null)), targetNode);
}
